var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbn = function SvgAbn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h31v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    d: "M-133-13040h986V336h-986z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#abn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F1EF",
    d: "M-53-12960h393V304H-53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-53-24h393v200H-53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009286",
    d: "M30.416 0H.5v25.013l14.958 14.958V9.93l14.958 14.958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3C000",
    d: "M30.416 25.012 15.458 39.97V9.928z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "abn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-53-12960h393V304H-53z"
  })))));
};
export default SvgAbn;